import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { constants } from '../utils';
import {
  MonthWrapper,
  TopicWrapper,
  AudienceWrapper,
} from '../StyledComponents';
import { StyledSelect } from '../../../shared/FormStyles';

import { Option } from '../Option.jsx';

import { renderMonthOptions } from '../utils/filtersHelpers';

const FilterList = styled.div`
  display: flex;
  justify-content: space-between;
  input[type='text'] {
    margin: 0;
  }
`;

export const PlanTabFiltersComponent = props => {
  const { t } = useTranslation('edit');
  return (
    props.appLoaded && (
      <FilterList
        className="js-tiles-index-filter-bar"
        isUserSiteAdmin={props.isUserSiteAdmin}
      >
        <MonthWrapper>
          <StyledSelect
            onChange={(val, act) => {
              props.handleFilterChange(val, act, 'month');
            }}
            className="date-filter"
            components={{
              IndicatorSeparator: () => null,
            }}
            classNamePrefix="react-select"
            placeholder={t('allMonths')}
            value={props.tileStatusNav[props.activeStatus].filter.month}
            isClearable={true}
            options={renderMonthOptions(props.activeStatus)}
            isSearchable={true}
          />
        </MonthWrapper>

        <TopicWrapper>
          <StyledSelect
            onMenuOpen={props.populateBoardSettings}
            isLoading={props.ribbonTagsLoading}
            onChange={(val, act) => {
              props.handleFilterChange(val, act, 'ribbonTag');
            }}
            className="ribbon-tag-filter"
            classNamePrefix="react-select"
            placeholder={t('allTopics')}
            value={props.tileStatusNav[props.activeStatus].filter.ribbonTag}
            isClearable={true}
            options={[constants.TOPIC_SETTINGS].concat(...props.ribbonTags)}
            isSearchable={true}
            components={{
              Option,
              IndicatorSeparator: () => null,
            }}
          />
        </TopicWrapper>

        {props.audiencesEnabled && (
          <AudienceWrapper>
            <StyledSelect
              onMenuOpen={props.populateBoardSettings}
              isLoading={props.audienceLoading}
              onChange={(val, act) => {
                props.handleFilterChange(val, act, 'audience');
              }}
              className="audience-filter"
              classNamePrefix="react-select"
              placeholder={t('allAudiences')}
              value={props.tileStatusNav[props.activeStatus].filter.audience}
              isClearable={true}
              options={[constants.AUDIENCE_SETTINGS].concat(...props.audiences)}
              isSearchable={true}
              components={{
                Option,
                IndicatorSeparator: () => null,
              }}
            />
          </AudienceWrapper>
        )}
      </FilterList>
    )
  );
};

export default PlanTabFiltersComponent;
